import React, { useEffect, useState } from "react";
import "../dashboard/Profile/section/Privacy_policy.css";
import { toastMessage } from "../../utils/toastMessage";
import { fetchCmsDataApi } from "../../services/faqs";
import { fetchPublicCmsDataApi } from "../../services/common";
import Header from "../../components/header/Header";
import Footer from "../landingpage/section/Footer";

const About = () => {
  const [aboutData, setAbout] = useState("");

  const getAboutHandler = async () => {
    try {
      const { data } = await fetchPublicCmsDataApi({ type: "ABOUT-US" });
      const { data: privacy, success, message } = data;
      if (success) {
        // toastMessage(message, "success", "about");
        setAbout(privacy);
      }
    } catch (e) {
      console.log("Login:-", e.message);
    }
  };

  //   console.log(aboutData, "aboutData");

  useEffect(() => {
    getAboutHandler();
  }, []);

  return (
    <>
      <Header />

      <div className="Privacy_policy about">
        <div className="container_privacy_policy">
          <div className="custom_container">
            <div className="privacy_policy_title">
              <h2>About Us</h2>
            </div>

            <p
              dangerouslySetInnerHTML={{
                __html: aboutData?.description,
              }}
            ></p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;
